module.exports = __webpack_public_path__ + "static/img/20005D_1_2_R_20220718_LC.ef5e0ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20005D_1_2_R_20220718_LC.png
// module id = n/HO
// module chunks = 0